import { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppKit, useAppKitAccount } from "@reown/appkit/react";
import { UserContext } from "../../provider/userprovider";
import walletIcon from "../../assets/svg/Wallet.png";
import "./index.scss";

const hasStoredSession = () =>
  Boolean(localStorage.getItem("pnl_token") || localStorage.getItem("address"));

const WalletGateOverlay = () => {
  const [searchParams] = useSearchParams();
  const { open } = useAppKit();
  const { isConnected, status } = useAppKitAccount();
  const user = useContext(UserContext);
  const [sessionChecked, setSessionChecked] = useState(() => !hasStoredSession());

  const isLeaderboardTab = searchParams.get("tab") === "leaderboard";
  const isWalletSettling = status === "connecting" || status === "reconnecting";
  const hasStoredAuth = Boolean(localStorage.getItem("pnl_token"));
  const isRestoringSession = hasStoredAuth && !user.userInfo.isLogin;

  useEffect(() => {
    if (isConnected || user.userInfo.isLogin) {
      setSessionChecked(true);
      return;
    }

    if (!hasStoredSession()) {
      setSessionChecked(true);
      return;
    }

    if (isWalletSettling || isRestoringSession || user.userInfo.dataloading) {
      return;
    }

    setSessionChecked(true);
  }, [
    isConnected,
    user.userInfo.isLogin,
    isWalletSettling,
    isRestoringSession,
    user.userInfo.dataloading,
  ]);

  const show =
    sessionChecked &&
    !isLeaderboardTab &&
    !isConnected &&
    !user.userInfo.isLogin;

  useEffect(() => {
    if (!show) return;

    document.documentElement.classList.add("wallet-gate-open");
    document.body.classList.add("wallet-gate-open");

    return () => {
      document.documentElement.classList.remove("wallet-gate-open");
      document.body.classList.remove("wallet-gate-open");
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      className="wallet-gate-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="wallet-gate-title"
    >
      <div className="wallet-gate-overlay__content">
        <p id="wallet-gate-title" className="wallet-gate-overlay__title">
          Connect Your Wallet To Continue
        </p>
        <button
          type="button"
          className="connect-wallet-buttonPre"
          aria-label="Connect wallet"
          onClick={() => open()}
        >
          <div className="wallet-contain">
            <img src={walletIcon} alt="Wallet Icon" className="wallet-icon" />
          </div>
          <span className="connect-text3 shimmer-text">CONNECT</span>
        </button>
      </div>
    </div>
  );
};

export default WalletGateOverlay;
